import { Building2, Landmark } from 'lucide-react';
import SendMoneyMethodCard from './send-money-method-card';

type SendMoneyMethodOptionsProps = {
  onExternalTransfer: () => void;
};

export default function SendMoneyMethodOptions({ onExternalTransfer }: SendMoneyMethodOptionsProps) {
  return (
    <section aria-label="Send money methods" className="grid min-w-0 grid-cols-1 gap-[1.2rem] sm:grid-cols-2 sm:gap-[1.6rem]">
      <SendMoneyMethodCard
        title="Internal transfer"
        description="Move money between wallets within your NexenX entity."
        icon={Building2}
        badge="Not available yet"
        disabled
        onSelect={() => undefined}
      />
      <SendMoneyMethodCard
        title="External transfer"
        description="Send money to another Client or Entity using its recipient public code."
        icon={Landmark}
        onSelect={onExternalTransfer}
      />
    </section>
  );
}
